// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"38bb31ef","513":"d9e05ebc","703":"71ce3de5"}[chunkId] + ".chunk.js";
};